<template>

  <div style="display:inline-block">
    <div>
      <button type="button" v-model="checked"
              :class="classObject"
              :style="{ width: width, height: height }"
              @click="value = !value">
        <template v-if="iconOn.length > 0">
          <don-icon :name="iconOn" v-if="value" :tamanyo="tamanyoStyleIcon"></don-icon>
          <don-icon :name="iconOff" :tamanyo="tamanyoStyleIcon" v-else></don-icon>
        </template>
        <template v-else>
          <template v-if="value">
            {{textOn}}
          </template>
          <template v-else>
            {{textOff}}
          </template>
        </template>
      </button>
    </div>
  </div>

</template>

<script>
  import icon from '../global/don.icon.vue'

  export default {
    name: 'donCheckbox',
    components: { donIcon: icon },
    props: {
      tamanyoStyleIcon: {
        type: String,
        default: 'fa-2x'
      },
      checked: {
        type: Boolean,
        default: false
      },
      iconOn: {
        type: String,
        default: ''
      },
      iconOff: {
        type: String,
        default: ''
      },
      textOn: {
        type: String,
        default: 'on'
      },
      textOff: {
        type: String,
        default: 'off'
      },
      styleOn: {
        type: String,
        default: 'btn-success'
      },
      styleOff: {
        type: String,
        default: 'btn-warning'
      },
      width: {
        type: String,
        default: ''
      },
      height: {
        type: String,
        default: ''
      },
      tamanyo: {
        type: String,
        default: 'btn-sm'
      }
    },
    watch: {
      checked: function (val) {
        this.value = val;
      },
      value: function () {
        this.$emit('change', this.value)
      }
    },
    data() {
      var chk = this.checked;
      return {
        value: chk
      };
    },
    computed:
    {
      classObject() {
        var result = 'btn ';
        result += this.tamanyo.length > 0 ? this.tamanyo + ' ' : '';
        result += this.value ? this.styleOn : this.styleOff;
        return result;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/componentes/global/don.checkbox.vue